  <div class="checkBoxTitle">
    <mat-checkbox #ref (change)="$event ? masterToggle(ref) : null"
        (click)="uncheckNone()"
        [checked]="isAllSelected()"
        [indeterminate]="!isAllSelected()"
        [disabled]="allCbDisabled">
        {{title}}
    </mat-checkbox>
  </div>
        
  <div class="row mb-1">
    <ng-container *ngFor="let row of list; let i= index">
      <ng-container *ngIf='row.bus_impact_name'>
        <div  [ngClass]="{'col-xl-12': fullWidth , 'col-xl-6': !fullWidth }" class="pl-4">
          <mat-checkbox (click)="$event.stopPropagation(); uncheckNone() "
            (change)="$event ? selection.toggle(row) : null;isSomeSelected()"
            [checked]="isPreSelected(row)" [value]="row.bus_impact_id"
            [disabled]="allCbDisabled">
            {{row.bus_impact_name}}
            
          </mat-checkbox>
        </div>
      </ng-container>
      <ng-container *ngIf='row.name' > 
        
        <div  [ngClass]="{'col-xl-12': fullWidth , 'col-xl-6': !fullWidth }" class="pl-4">
          <mat-checkbox (click)="$event.stopPropagation(); uncheckNone() "
            (change)="$event ? selection.toggle(row) : null;isSomeSelected()"
            [checked]="isPreSelected(row)" [value]="row.id"
            [disabled]="allCbDisabled">
            {{row.name}}
            
          </mat-checkbox>
        </div>
        
        
        </ng-container>





    
      
    </ng-container>
  </div>
        
          
    
    
    <!-- Copyright 2018 Google Inc. All Rights Reserved.
        Use of this source code is governed by an MIT-style license that
        can be found in the LICENSE file at http://angular.io/license -->